module.exports = __webpack_public_path__ + "img/zoom-in-inactive.fbee1c5d.svg";